(() => {
  const initOpenWhen = (root) => {
    if (!root || root.dataset.ysOpenWhenReady === 'true') return;
    root.dataset.ysOpenWhenReady = 'true';

    const body = document.body;
    const cardViews = [...root.querySelectorAll('[data-ys-card-view]')];
    const openButtons = [...root.querySelectorAll('[data-ys-card-open]')];
    const installModal = root.querySelector('[data-ys-install-modal]');

    const setLocked = (locked) => {
      body.classList.toggle('ys-open-when-lock', locked);
    };

    const closeCards = () => {
      cardViews.forEach((view) => {
        view.classList.remove('is-open');
        view.setAttribute('aria-hidden', 'true');
      });
      setLocked(Boolean(installModal?.classList.contains('is-open')));
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-ys-card-open');
        const view = id ? root.querySelector(`#${CSS.escape(id)}`) : null;
        if (!view) return;

        const image = view.querySelector('[data-ys-card-image]');
        if (image && !image.getAttribute('src')) {
          image.setAttribute('src', image.dataset.src || '');
        }

        closeCards();
        view.classList.add('is-open');
        view.setAttribute('aria-hidden', 'false');
        setLocked(true);
        view.querySelector('[data-ys-card-close]')?.focus({ preventScroll: true });
      });
    });

    root.querySelectorAll('[data-ys-card-close]').forEach((button) => {
      button.addEventListener('click', closeCards);
    });

    const openInstall = () => {
      if (!installModal) return;
      installModal.classList.add('is-open');
      installModal.setAttribute('aria-hidden', 'false');
      setLocked(true);
      installModal.querySelector('[data-ys-install-close]')?.focus({ preventScroll: true });
    };

    const closeInstall = () => {
      if (!installModal) return;
      installModal.classList.remove('is-open');
      installModal.setAttribute('aria-hidden', 'true');
      setLocked(cardViews.some((view) => view.classList.contains('is-open')));
    };

    root.querySelector('[data-ys-install-open]')?.addEventListener('click', openInstall);
    root.querySelectorAll('[data-ys-install-close]').forEach((button) => {
      button.addEventListener('click', closeInstall);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (installModal?.classList.contains('is-open')) {
        closeInstall();
        return;
      }
      if (cardViews.some((view) => view.classList.contains('is-open'))) {
        closeCards();
      }
    });
  };

  const boot = () => document.querySelectorAll('[data-ys-open-when]').forEach(initOpenWhen);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-ys-open-when]').forEach(initOpenWhen);
  });
})();
